import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute = ({ children, roles = [] }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // اگر کاربر لاگین نکرده باشد، او را به صفحه لاگین هدایت می‌کنیم
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles.length > 0 && !roles.includes(user.role)) {
    // اگر نقش کاربر به این مسیر نخورد، به مسیر صحیح‌تری هدایت شود
    if (user.role === "admin") {
      return <Navigate to="/admin" replace />;
    } else if (user.role === "user") {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children; // اگر همه چیز درست بود، محتوای داخل PrivateRoute نمایش داده می‌شود
};

export default PrivateRoute;
